/**
 * Soft decorative organic blobs used as section backgrounds.
 * Pass `variant` to tint differently.
 */
export default function OrganicShapes({ variant = "green", className = "" }) {
    const tints = {
        green: ["bg-seedh-surface-green", "bg-seedh-surface-blue"],
        blue: ["bg-seedh-surface-blue", "bg-seedh-surface-beige"],
        beige: ["bg-seedh-surface-beige", "bg-seedh-surface-green"],
        mixed: ["bg-seedh-surface-blue", "bg-seedh-surface-green"],
    };
    const [a, b] = tints[variant] || tints.green;
    return (
        <div
            aria-hidden
            className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
        >
            <div
                className={`absolute -top-32 -left-32 w-[460px] h-[460px] rounded-full ${a} blur-3xl opacity-60`}
            />
            <div
                className={`absolute -bottom-32 -right-32 w-[520px] h-[520px] rounded-full ${b} blur-3xl opacity-50`}
            />
        </div>
    );
}
